import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

import { cn } from '@/lib/utils';

const MAX_VISIBLE_CHIPS = 3;

const CHIP_CLASS_NAME =
  'bg-muted inline-flex h-5.5 items-center rounded-sm px-1.5 text-xs font-medium whitespace-nowrap';

type ValueChipsProps = {
  values: { id: number | string; name: string }[];
};

export const ValueChips = (props: ValueChipsProps) => {
  const { values } = props;

  if (values.length === 0) {
    return '—';
  }

  const visibleValues = values.slice(0, MAX_VISIBLE_CHIPS);
  const hiddenValues = values.slice(MAX_VISIBLE_CHIPS);

  return (
    <div className="flex flex-wrap gap-1">
      {visibleValues.map(({ id, name }) => (
        <span
          key={id}
          className={cn(CHIP_CLASS_NAME, 'text-foreground')}
        >
          {name}
        </span>
      ))}
      {hiddenValues.length > 0 && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              tabIndex={0}
              className={cn(CHIP_CLASS_NAME, 'text-muted-foreground')}
            >
              +{hiddenValues.length}
            </span>
          </TooltipTrigger>
          <TooltipContent className="flex flex-col gap-0.5">
            {hiddenValues.map(({ id, name }) => (
              <span key={id}>{name}</span>
            ))}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};
